import {
  AgeRange,
  AudienceInsightsDimensions,
  Gender,
  GoogleGeoLocation
} from '@blisspointmedia/bpm-types/dist/YoutubePlanning';
import { PAGE_NAMES } from '@Components/Page/page-constants';

export const PAGE_TITLE = PAGE_NAMES.YOUTUBE_PLANNING;

export const INTEREST_SEARCH_DIMENSIONS = [
  AudienceInsightsDimensions.KNOWLEDGE_GRAPH,
  AudienceInsightsDimensions.CATEGORY
];

export const Tab = {
  BUILD: 'build-recommendation',
  DISCOVER: 'discover',
  SETS: 'creator-sets'
} as const;
export type TabValue = (typeof Tab)[keyof typeof Tab];

export const TAB_NAVS: { key: TabValue; label: string }[] = [
  { key: Tab.BUILD, label: 'Build Recommendation' },
  { key: Tab.DISCOVER, label: 'Discover Creators' },
  { key: Tab.SETS, label: 'Creator Sets' }
];

// Gates the creator tabs (not the page), so Build Recommendation is unaffected without it.
export const CREATOR_DISCOVERY_EXPERIMENT = 'enableYoutubeCreatorDiscovery';
export const CREATOR_TABS: TabValue[] = [Tab.DISCOVER, Tab.SETS];

export const GOAL_OPTIONS = [
  'Efficient Reach (Awareness)',
  // 'Efficient Completions (Awareness)', // TODO: Add back when Google supports Non-Skippable Surfaces
  'Maximize Views (Considerations)'
  // 'Online Conversions (Action)', // TODO: Add back when Google offers Demand Gen
];

export const ALL_STATES_ID = -1;
export const ALL_STATES: GoogleGeoLocation = {
  id: ALL_STATES_ID,
  name: 'All States'
};
export const ALL_STATES_VALUE = String(ALL_STATES_ID);

const isGenderKey = (val: string): val is keyof typeof Gender => val in Gender;
export const isAgeKey = (val: string): val is keyof typeof AgeRange => val in AgeRange;

export const AGE_KEYS = Object.keys(AgeRange).filter(isAgeKey);
export const GENDER_KEYS = Object.keys(Gender).filter(isGenderKey);
